module.exports = __webpack_public_path__ + "static/media/bkg09d.dc2eabd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg09d.jpg
// module id = 471
// module chunks = 0